import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

const Login = resolve => require(['@/views/login'], resolve) // 登录
const Empty = resolve => require(['@/views/empty'], resolve) // 空白跳转页
// const DoctorInfo = resolve => require(['@/views/doctor-info'], resolve) // 医生注册认证
const CompanyRegister = resolve => require(['@/views/company-register'], resolve) // 医企端企业认证
const OSSUrl = resolve => require(['@/views/get-file-OssUrl'], resolve) // 获取文件链接
const Privacy = resolve => require(['@/views/privacy'], resolve) // 隐私协议
const Service = resolve => require(['@/views/service'], resolve) // 服务协议
const AppDownload = resolve => require(['@/views/app-download'], resolve) // app下载页面

// const LeadLogin = resolve => require(['@/views/lead'], resolve) // 领导登录
// const LeadReg = resolve => require(['@/views/lead-reg'], resolve) // 领导注册

const Index = resolve => require(['@/views/home/index'], resolve) // 主界面入口

const ChronicList = resolve => require(['@/views/home/chronic/list'], resolve) // 慢阻肺管理列表
const ChronicDetail = resolve => require(['@/views/home/chronic/detail-member'], resolve) // 人员管理 普通医生
const ChronicDetail2 = resolve => require(['@/views/home/chronic/detail-admin'], resolve) // 人员管理 管理员
const ChronicOrganizationChart = resolve => require(['@/views/home/chronic/organization-chart-blank-member'], resolve) // 监测点配置 普通医生
const ChronicOrganizationChart2 = resolve => require(['@/views/home/chronic/organization-chart-blank-admin'], resolve) // 监测点配置 管理员


const ChronicLists = resolve => require(['@/views/chronic-list/list'], resolve)// 慢阻肺记录列表
const ChronicStatics = resolve => require(['@/views/chronic-list/statistics'], resolve)// 慢阻肺数量统计
const ChronicAge = resolve => require(['@/views/chronic-list/age'], resolve)// 慢阻肺年龄段统计
const ChronicProportion = resolve => require(['@/views/chronic-list/proportion'], resolve)// 慢阻肺占比统计
const ChronicRecord = resolve => require(['@/views/chronic-list/record'], resolve)// 慢阻肺检测记录列表
const ChronicPrint = resolve => require(['@/views/chronic-list/print'], resolve)// 慢阻肺检测记录打印
const ChronicTimeTrend = resolve => require(['@/views/chronic-list/time-trend'], resolve)// 慢阻肺时间趋势图
const ChronicSite = resolve => require(['@/views/chronic-list/site'], resolve)// 站点检测数量图
const ChronicMainPage = resolve => require(['@/views/chronic-list/mainpage'], resolve)// 数据统计页面

const StructureDoctor = resolve => require(['@/views/personnel-structure/doctor'], resolve)// 人员架构-医生列表
const StructureWorker = resolve => require(['@/views/personnel-structure/worker-manage'], resolve)// 人员架构-人员管理
const StructureAddDoctor = resolve => require(['@/views/personnel-structure/add-worker'], resolve)// 人员架构-医生添加编辑
const StructureNurse = resolve => require(['@/views/personnel-structure/nurse'], resolve)// 人员架构-护士列表
const StructureAddNurse = resolve => require(['@/views/personnel-structure/add-nurse'], resolve)// 人员架构-护士添加编辑

const PatientList = resolve => require(['@/views/patient/patient-list'], resolve)// 慢阻肺管理-患者列表
const AddPatient = resolve => require(['@/views/patient/add-patient'], resolve)// 慢阻肺管理-添加患者
const CopdAppointmentList = resolve => require(['@/views/order-manager/copd-appointment-list'], resolve)// 慢阻肺管理-预约订单
const CopdScheduingManage = resolve => require(['@/views/order-manager/scheduling-manage'], resolve)// 慢阻肺管理-排班const
const CopdReport = resolve => require(['@/views/order-manager/copd-report'], resolve)// 慢阻肺检测报告

// // 医生角色
const ReexamineAppointment = resolve => require(['@/views/doctor/reexamine-appointment'], resolve) // 复查管理 复检预约
const ReexamineQuestionnaire = resolve => require(['@/views/doctor/reexamine-questionnaire'], resolve) // 复查管理 随访问卷
const StartAnswerQuestions = resolve => require(['@/views/doctor/start-answer-questions'], resolve) // 复查管理 随访问卷 开始答题
const SitePersonal = resolve => require(['@/views/doctor/personal-management'], resolve)
const DoubleCheckRecord = resolve => require(['@/views/doctor/double-check-record'], resolve)
const DoubleCheckRehabilitation = resolve => require(['@/views/doctor/double-check-rehabilitation'], resolve)
// 患者管理   病例档案
const MedicalRecords = resolve => require(['@/views/doctor/medical-records'], resolve)
//患者管理-复检
const Recheck = resolve => require(['@/views/doctor/recheck'], resolve)
//患者管理-康复
const Recovery = resolve => require(['@/views/doctor/recovery'], resolve)
//随访--随访方案列表
const ProtocolList = resolve => require(['@/views/doctor/protocollist'], resolve)
//随访--预约列表
const SubscribeList = resolve => require(['@/views/doctor/subscribelist'], resolve)
//随访--执行列表
const ExecutionList = resolve => require(['@/views/doctor/executionlist'], resolve)
//随访--执行完成
const ExecutionCompleted = resolve => require(['@/views/doctor/executioncompleted'], resolve)

// 模块化开发改版 医生端
//诊疗中心--综合门诊
const Comprehensive = resolve => require(['@/views/doctor/outpatient-comprehensive'], resolve)
//诊疗中心--综合门诊--撰写方案
const WritePlan = resolve => require(['@/views/doctor/write-plan'], resolve)
// 诊疗中心--检验检测
const Check = resolve => require(['@/views/modularity/outpatient-check'], resolve)
// 查看病历
const CheckMedicalRecords = resolve => require(['@/views/modularity/check-medical-records'], resolve)
// 候诊中心--预约列表
const DiagnosisAppointment = resolve => require(['@/views/modularity/diagnosis-appointment'], resolve)
// 候诊中心--预约绿通
const DiagnosisGreenAppointment = resolve => require(['@/views/modularity/diagnosis-green-appointment'], resolve)
// 候诊中心--候诊列表
const DiagnosisList = resolve => require(['@/views/modularity/diagnosis-list'], resolve)
// 诊后管理--随访列表
const FollowupNewList = resolve => require(['@/views/modularity/followup-new-list'], resolve)
// 诊后管理--转诊记录
const FollowupTransferRocord = resolve => require(['@/views/modularity/followup-transfer-record'], resolve)
// 诊后管理-随访管理
const FollowupManage = resolve => require(['@/views/modularity/followup-manage'], resolve)
// 执行随访
const ExecutionFollowup = resolve => require(['@/views/modularity/execution-followup'], resolve)
// 预约中心--随访预约
const AppointmentCenterFollowList = resolve => require(['@/views/modularity/appointment-center-followup'], resolve)
// 预约中心--转诊预约
const AppointmentCenterTransferList = resolve => require(['@/views/modularity/appointment-center-transfer'], resolve)
// 预约中心--预约通知
const AppointmentCenterNotify = resolve => require(['@/views/modularity/appointment-center-notify'], resolve)
// 随访结果查看
const FollowupResult = resolve => require(['@/views/modularity/followup-result'], resolve)
// // 问卷调查--问卷随访结果查看
// const FollowupResultQue = resolve => require(['@/views/modularity/followup-result-que'], resolve)
// 事务中心-转诊待办
const BusinessCenterTransfer = resolve => require(['@/views/modularity/business-center-transfer'], resolve)
// 事务中心-通知待办
const BusinessCenterNotify = resolve => require(['@/views/modularity/business-center-notify'], resolve)
// 事务中心-随访待办
const BusinessCenterFollowUp = resolve => require(['@/views/modularity/business-center-followup'], resolve)

// 统计报表
// 问卷报表
const QueReport = resolve => require(['@/views/copd-report/que-report'], resolve)
// 预约报表
const ReservationReport = resolve => require(['@/views/copd-report/reservation-report'], resolve)
// 门诊报表
const OutpatientReport = resolve => require(['@/views/copd-report/outpatient-report'], resolve)
// 转诊报表
const TransferReport = resolve => require(['@/views/copd-report/transfer-report'], resolve)
// 随访报表
const FollowUpReport = resolve => require(['@/views/copd-report/followUp-report'], resolve)
// 检测报表
const CheckReport = resolve => require(['@/views/copd-report/check-report'], resolve)


// 管理员端
//排班管理
const SchedulingManage = resolve => require(['@/views/modularity-manager/scheduling-manage'], resolve)
//人员管理
const DoctorManage = resolve => require(['@/views/modularity-manager/doctor-manage'], resolve)
//站点管理
const SiteManage = resolve => require(['@/views/modularity-manager/site-manage'], resolve)
//权限管理
const SetPermission = resolve => require(['@/views/modularity-manager/setPermission'], resolve)
//早筛报表
const PresieveReport = resolve => require(['@/views/report-form/presieve-report'], resolve)

// 平台超级管理员
// 医生管理
const DoctorUser = resolve => require(['@/views/platform-user/doctor-user'], resolve)
// 护士管理
const NurseUser = resolve => require(['@/views/platform-user/nurse-user'], resolve)
// 医院管理员
const HospitalAdmin = resolve => require(['@/views/platform-user/hospital-admin'], resolve)
// 医生审核
const AuditDoctor = resolve => require(['@/views/platform-user/auditDoctor'], resolve)
// 护士审核
const AuditNurse = resolve => require(['@/views/platform-user/auditNurse'], resolve)
// 护士服务列表
const NurseServeList = resolve => require(['@/views/platform-user/nurse-service/serve-list'], resolve)
//护士服务编辑
const NurseServeEdit = resolve => require(["@/views/platform-user/nurse-service/edit-serve"],resolve);
//护士服务审核
const NurseServeAudit = resolve => require(["@/views/platform-user/nurse-service/audit-serve"],resolve);  
//护士订单管理
const NurseOrder = resolve => require(["@/views/platform-user/nurse-service/nurse-order"],resolve);  
//医企端注册企业审核
const EnterpriseAudit = resolve => require(["@/views/platform-user/enterprise-audit"],resolve);  
//医企端注册企业审核信息
const EnterpriseAuditInfo = resolve => require(["@/views/platform-user/enterprise-audit-info"],resolve);  
//服务器日志
const ServerLog = resolve => require(["@/views/platform-user/server-log"],resolve);  
//平台给企业充值 平台流水
const WalletCharge = resolve => require(["@/views/platform-user/ep-account/wallet-charge"],resolve);  
//资质审核
const QualificationAudit = resolve => require(["@/views/platform-user/audit/qualification-audit"],resolve);  
//资质审核详情
const QualificationAuditInfo = resolve => require(["@/views/platform-user/audit/qualification-audit-info"],resolve);  
// 配置操作
// 资质角色管理
const ConfigurationQualification = resolve => require(["@/views/platform-user/configuration/qualification-manage"],resolve);  
// 合作申请
const OffcialWebsite = resolve => require(["@/views/platform-user/cooperate/offcial-website"],resolve);  


// 医企端路由组件
// 组织架构 人员管理
const EnterpriseUser = resolve => require(["@/views/enterprise/framework/ep-user"],resolve);
// 组织架构 身份管理
// const RoleManage = resolve => require(["@/views/enterprise/framework/role-manage"],resolve);
// 组织架构 身份管理 身份信息编辑
const RoleInfoEdit = resolve => require(["@/views/enterprise/framework/roleInfo-edit"],resolve);
// 组织架构 企业产品
const EpProdects = resolve => require(["@/views/enterprise/framework/ep-products"],resolve);
// 组织架构 新增产品
const AddProdects = resolve => require(["@/views/enterprise/framework/add-products"],resolve);
// 组织架构 关联产品
const ConnectProdects = resolve => require(["@/views/enterprise/framework/connect-products"],resolve);

//文件预览
const FilePreview = resolve => require(["@/views/enterprise/account/file-preview"],resolve);

// 操作台 企业关联
const EpConnect = resolve => require(["@/views/enterprise/operate/ep-connect"],resolve);
// 审核文章列表
const AuditArticle = resolve => require(["@/views/enterprise/operate/article/audit-article"],resolve);
// 文章审核信息
const ArticleDetail = resolve => require(["@/views/enterprise/operate/article/article-detail"],resolve);
// 发布文章
const ReleaseArticle = resolve => require(["@/views/enterprise/operate/article/release-article"],resolve);
// 编辑文章
const EditArticle = resolve => require(["@/views/enterprise/operate/article/edit-article"],resolve);
// 文章分组
// const ArticleGroup = resolve => require(["@/views/enterprise/operate/article/article-group"],resolve);
// 考题列表
const QuestionList = resolve => require(["@/views/enterprise/operate/question/question-list"],resolve);
// 添加考题
const CreateQuestion = resolve => require(["@/views/enterprise/operate/question/create-question"],resolve);
// 发布任务
const TaskManage = resolve => require(["@/views/enterprise/operate/task/task-manage"],resolve);
// 新建任务
const TaskCreate = resolve => require(["@/views/enterprise/operate/task/task-create"],resolve);
// 任务详情
const TaskDetail = resolve => require(["@/views/enterprise/operate/task/task-detail"],resolve);
// 任务审核
const TaskAudit = resolve => require(["@/views/enterprise/operate/task/task-audit"],resolve);
// 任务审核详情
const TaskAuditInfo = resolve => require(["@/views/enterprise/operate/task/task-audit-info"],resolve);
// 任务结算
const TaskSettle = resolve => require(["@/views/enterprise/operate/task/task-settle"],resolve);
// 阅读任务 读文章
const TaskRead = resolve => require(["@/views/enterprise/operate/task/task-read"],resolve);

// 工具箱 管理员流向报表
const FlowReport = resolve => require(["@/views/enterprise/tool/flow-report"],resolve);
// 工具箱 用户流向报表
const FlowReportUser = resolve => require(["@/views/enterprise/tool/flow-report-user"],resolve);
// 工具箱 模版管理
const TempleteManage = resolve => require(["@/views/enterprise/tool/templete-manage"],resolve);
// 工具箱 模版管理
const TempleteCreate = resolve => require(["@/views/enterprise/tool/create-templete"],resolve);
// 报表权限
const ReportPermission = resolve => require(["@/views/enterprise/tool/report-permission-manage"],resolve);
// 报表权限
const ReportPermissionCreate = resolve => require(["@/views/enterprise/tool/report-permission-create"],resolve);

// 运营中心
// 钱包账号
const WalletEp = resolve => require(["@/views/enterprise/fund/wallet/ep-wallet"],resolve);
const WalletUser = resolve => require(["@/views/enterprise/fund/wallet/user-wallet"],resolve);

// 企业账号
// 企业信息更改
const EditEnterpriseInfo = resolve => require(["@/views/enterprise/account/edit-info"],resolve);

// 医企端用户身份进入
// 我的任务列表
const MyTaskList = resolve => require(["@/views/enterprise/operate/task/my-task-list"],resolve);
// 非管理员答题任务
const AnswerQueTask = resolve => require(["@/views/enterprise/operate/question/answer-question"],resolve);
// 答题详情
const AnswerQueDetail = resolve => require(["@/views/enterprise/operate/question/answer-detail"],resolve);
// 阅读文章
const ArticleRead = resolve => require(["@/views/enterprise/operate/article/article-read"],resolve);
// pdf预览
const ArticlePDF = resolve => require(["@/views/enterprise/operate/article/pdf-detail"],resolve);
// 出题任务
const CreateTaskQue = resolve => require(["@/views/enterprise/operate/task/create-task-que"],resolve);





// app下载
const Download = resolve => require(['@/views/registerIndex'], resolve)


// // 专家角色
const SpecialistRehabilitationTraining = resolve => require(['@/views/specialist/plan/rehabilitation'], resolve)
const SpecialistMedicinePlan = resolve => require(['@/views/specialist/plan/medicine'], resolve)
const SpecialistPatientList = resolve => require(['@/views/specialist/patient-list'], resolve)
const SpecialistPatientListToday = resolve => require(['@/views/specialist/patient-list/today-appointment'], resolve)
const SpecialistPatientInfo = resolve => require(['@/views/specialist/patient-list/info'], resolve)
const SpecialistPatientInfoBasic = resolve => require(['@/views/specialist/patient-list/basic-information'], resolve)
//预约列表-撰写方案
const SpecialistPatientInfoPlanMaking = resolve => require(['@/views/specialist/patient-list/plan-making-bak'], resolve)
const SpecialistPatientInfoMedicinePlan = resolve => require(['@/views/specialist/patient-list/medicine-plan'], resolve)
const SpecialistPatientInfo2 = resolve => require(['@/views/specialist/patient-list/info2'], resolve)
const SpecialistPatientInfoBasic2 = resolve => require(['@/views/specialist/patient-list/basic-information2'], resolve)
const SpecialistPatientRecords = resolve => require(['@/views/specialist/patient-list/patientRecords'], resolve)
const SpecialistPatientInfoPlanMaking2 = resolve => require(['@/views/specialist/patient-list/plan-making2'], resolve)
const SpecialistPatientInfoMedicinePlan2 = resolve => require(['@/views/specialist/patient-list/medicine-plan2'], resolve)



// // 非基层医院管理员
const specialistManagerDoctorManage = resolve => require(['@/views/specialist-manager/doctor-manage'], resolve)
const specialistManagerScheduleManagement = resolve => require(['@/views/specialist-manager/schedule-manage'], resolve)
const specialistManagerAppointmentManagement = resolve => require(['@/views/specialist-manager/appointment-manage'], resolve)

const NotFound = resolve => require(['@/views/notFound'], resolve)// 404

Vue.use(Router)


// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', alias: '/', name: 'LOGIN', component: Login, meta: { title: '登录' } },
    { path: '/empty', name: 'EMPTY', component: Empty, meta: { title: '空白页' } },
    // { path: '/doctorinfo', name: 'DOCTORINFO', component: DoctorInfo, meta: { title: '医生信息认证' } },
    { path: '/company-register', name: 'COMPANYREGISTER', component: CompanyRegister, meta: { title: '医生信息认证' } },
    // app下载页面
    { path: '/download', name: 'PF_APP_DOWNLOAD', component: AppDownload, meta: { title: 'app下载' } },
    { path: '/en/privacy', name: 'PF_PRIVACY', component: Privacy, meta: { title: '隐私协议' } },
    { path: '/en/registrationagreement', name: 'PF_SERVICE', component: Service, meta: { title: '服务协议' } },

    // {path: '/lead', alias: '/', name: 'LEAD_LOGIN', component: LeadLogin, meta: {title: '登录'}},
    // {path: '/lead/reg', name: 'LEAD_REG', component: LeadReg, meta: {title: '领导注册'}},
    {
      path: '/home',
      name: 'INDEX',
      component: Index,
      // redirect
      children: [
        // 慢阻肺管理
        { path: 'chronic', name: 'PF_CHRONIC_USER', component: ChronicList, meta: { title: '系统管理', keepAlive: true } },
        { path: 'setting/doctor/user', name: 'PF_CHRONIC_SETTING_DOCTOR_USER', component: ChronicDetail, meta: { title: '普通医生人员管理' } },
        { path: 'setting/manager/user', name: 'PF_CHRONIC_SETTING_MANAGER_USER', component: ChronicDetail2, meta: { title: '管理员人员管理' } },
        { path: 'setting/doctor/site', name: 'PF_CHRONIC_SETTING_DOCTOR_SITE', component: ChronicOrganizationChart, meta: { title: '普通医生检测点配置' } },
        { path: 'setting/manager/site', name: 'PF_CHRONIC_SETTING_MANAGER_SITE', component: ChronicOrganizationChart2, meta: { title: '管理员检测点配置' } },

        // 慢阻肺记录
        { path: 'chronic', name: 'PF_CHRONIC_LIST', component: ChronicLists, meta: { title: '慢阻肺记录列表', keepAlive: true } },
        { path: 'chronic/statistics', name: 'PF_CHRONIC_STATISTICS', component: ChronicStatics, meta: { title: '慢阻肺数量统计' } },
        { path: 'chronic/age', name: 'PF_CHRONIC_AGE', component: ChronicAge, meta: { title: '慢阻肺年龄段统计' } },
        { path: 'chronic/proportion', name: 'PF_CHRONIC_PROPORTION', component: ChronicProportion, meta: { title: '慢阻肺占比统计' } },
        { path: 'chronic/record', name: 'PF_CHRONIC_RECORD', component: ChronicRecord, meta: { title: '慢阻肺检测记录结果' } },
        { path: 'chronic/print/:id', name: 'PF_CHRONIC_PRINT', component: ChronicPrint, meta: { title: '慢阻肺检测记录打印' } },
        { path: 'chronic/timeTrend', name: 'PF_CHRONIC_TIME_TREND', component: ChronicTimeTrend, meta: { title: '慢阻肺时间趋势图' } },
        { path: 'chronic/site', name: 'PF_CHRONIC_SITE', component: ChronicSite, meta: { title: '慢阻肺站点检测数量' } },
        { path: 'chronic/mainpage', name: 'PF_CHRONIC_MAINPAGE', component: ChronicMainPage, meta: { title: '慢阻肺数据统计页面' } },

        // 人员架构
        { path: 'personnel/structure/doctor', name: 'PF_PERSONNEL_STRUCTURE_DOCTOR', component: StructureDoctor, meta: { title: '医生列表', keepAlive: true } },
        { path: 'personnel/structure/workerManage', name: 'PF_PERSONNEL_STRUCTURE_WORKER_MANAGE', component: StructureWorker, meta: { title: '工作人员管理', keepAlive: true } },
        { path: 'personnel/structure/addDoctor', name: 'PF_PERSONNEL_STRUCTURE_ADD_DOCTOR', component: StructureAddDoctor, meta: { title: '添加医生' } },
        { path: 'personnel/structure/nurse', name: 'PF_PERSONNEL_STRUCTURE_NURSE', component: StructureNurse, meta: { title: '护士列表' } },
        { path: 'personnel/structure/add-nurse', name: 'PF_PERSONNEL_STRUCTURE_ADD_NURSE', component: StructureAddNurse, meta: { title: '添加护士' } },

        // 患者管理(旧)
        { path: 'patient/list', name: 'PF_PATIENT_LIST', component: PatientList, meta: { title: '患者列表', keepAlive: true } },
        { path: 'patient/add-patient', name: 'PF_ADD_PATIENT', component: AddPatient, meta: { title: '添加患者' } },
        { path: 'order/copd-appointment', name: 'PF_COPD_APPOINTMENT', component: CopdAppointmentList, meta: { title: '预约订单' } },
        { path: 'order/copd-report', name: 'PF_COPD_REPORT', component: CopdReport, meta: { title: '检测报告' } },
        // 预约排班管理
        { path: 'order/copd-scheduing', name: 'PF_COPD_SCHEDUING_MANAGE', component: CopdScheduingManage, meta: { title: '预约排班管理' } },

        // 医生角色  ---添加权限
        { path: 'reexamine/appointment', name: 'PF_REEXAMINE_APPOINTMENT', component: ReexamineAppointment, meta: { title: '复检预约' } },
        { path: 'reexamine/questionnaire', name: 'PF_REEXAMINE_QUESTIONNAIRE', component: ReexamineQuestionnaire, meta: { title: '随访问卷' } },
        { path: 'reexamine/questions', name: 'PF_REEXAMINE_ANSWER_QUESTIONS', component: StartAnswerQuestions, meta: { title: '随访问卷-开始答题' } },
        { path: 'personal', name: 'PF_REEXAMINE_PERSONAL_MANAGEMENT', component: SitePersonal, meta: { title: '人员管理' } },
        { path: 'outline', name: 'PF_OUTLINE_RECORD', component: PatientList, meta: { title: '录入管理' } },
        { path: 'outline/patients', name: 'PF_OUTLINE_PATIENTS_MANAGEMENT', component: PatientList, meta: { title: '用户管理' } },
        { path: 'reexamine/records', name: 'PF_REEXAMINE_RECORDS', component: DoubleCheckRecord, meta: { title: '用户管理' } },
        { path: 'reexamine/rehabilitation', name: 'PF_REEXAMINE_REHABILITATION', component: DoubleCheckRehabilitation, meta: { title: '康复训练' } },
        // 患者管理-病历档案
        { path: 'patientmanagement/medicalrecords', name: 'PF_PATIENTMANAGEMENT_MEDICALRECORDS', component: MedicalRecords, meta: { title: '病历档案' } },
        //患者管理-复检
        { path: 'patientmanagement/recheck', name: 'PF_PATIENTMANAGEMENT_RECHECK', component: Recheck, meta: { title: '复检' } },
        //患者管理-康复
        { path: 'patientmanagement/recovery', name: 'PF_PATIENTMANAGEMENT_RECOVERY', component: Recovery, meta: { title: '康复' } },
        //随访--随访方案列表
        { path: 'followup/protocolList', name: 'PF_FOLLOWUP_PROTOCOLLIST', component: ProtocolList, meta: { title: '预约列表' } },
        //随访--预约列表
        { path: 'followup/subscribelist', name: 'PF_FOLLOWUP_SUBSCRIBELIST', component: SubscribeList, meta: { title: '预约列表' } },
        //随访--执行列表
        { path: 'followup/executionlist', name: 'PF_FOLLOWUP_EXECUTIONLIST', component: ExecutionList, meta: { title: '执行列表' } },
        //随访--执行完成
        { path: 'followup/executioncompleted', name: 'PF_FOLLOWUP_EXECUTIONCOMPLETED', component: ExecutionCompleted, meta: { title: '执行完成' } },

        // 模块化开发改版 医生端
        //诊疗中心--综合门诊
        { path: 'outpatient/comprehensive', name: 'PF_OUTPATIENT_COMPREHENSIVE', component: Comprehensive, meta: { title: '综合门诊' } },
        //诊疗中心--综合门诊--撰写方案
        { path: 'outpatient/writeplan', name: 'PF_OUTPATIENT_WRITEPLAN', component: WritePlan, meta: { title: '综合门诊--撰写方案' } },
        // 诊疗中心--检验检测
        { path: 'outpatient/check', name: 'PF_OUTPATIENT_CHECK', component: Check, meta: { title: '检验检测' } },
        // 查看病历
        { path: 'medical/records', name: 'PF_MEDICAL_RECORDS', component: CheckMedicalRecords, meta: { title: '查看病历' } },
        //候诊中心--预约列表
        { path: 'wait-diagnosis/appointment', name: 'PF_WAIT_DIAGNOSIS_APPOINTMENT', component: DiagnosisAppointment, meta: { title: '候诊中心--预约列表' } },
        //候诊中心--预约绿通
        { path: 'wait-diagnosis/green-appointment', name: 'PF_WAIT_DIAGNOSIS_GREEN_APPOINTMENT', component: DiagnosisGreenAppointment, meta: { title: '候诊中心--预约绿通' } },
        //候诊中心--候诊列表
        { path: 'wait-diagnosis/list', name: 'PF_WAIT_DIAGNOSIS_LIST', component: DiagnosisList, meta: { title: '候诊中心--候诊列表' } },
        //诊后管理--随访列表
        { path: 'followup/new-list', name: 'PF_FOLLOWUP_NEW_LIST', component: FollowupNewList, meta: { title: '诊后管理--随访列表' } },
        //诊后管理--转诊记录
        { path: 'followup/transfer-record', name: 'PF_FOLLOWUP_TRANSFER_RECORD', component: FollowupTransferRocord, meta: { title: '诊后管理--转诊记录' } },
        //诊后管理--随访管理
        { path: 'followup/manage', name: 'PF_FOLLOWUP_MANAGE', component: FollowupManage, meta: { title: '随访管理' } },
        //执行随访
        { path: 'followup/execution', name: 'PF_FOLLOWUP_EXECUTION', component: ExecutionFollowup, meta: { title: '执行随访' } },
        //预约中心--随访预约
        { path: 'appointment-center/followup-list', name: 'PF_APPOINTMENT_CENTER_FOLLOWUP_LIST', component: AppointmentCenterFollowList, meta: { title: '预约中心--随访预约' } },
        //预约中心--转诊预约
        { path: 'appointment-center/transfer-list', name: 'PF_APPOINTMENT_CENTER_TRANSFER_LIST', component: AppointmentCenterTransferList, meta: { title: '预约中心--转诊预约' } },
        //预约中心--预约通知
        { path: 'appointment-center/notify', name: 'PF_APPOINTMENT_CENTER_NOTIFY', component: AppointmentCenterNotify, meta: { title: '预约中心--预约通知' } },
        //随访结果查看
        { path: 'outpatient/followup-result', name: 'PF_FOLLOWUP_RESULT', component: FollowupResult, meta: { title: '随访执行结果' } },
        // //问卷调查--随访结果查看
        // { path: 'outpatient/followup-result-que', name: 'PF_FOLLOWUP_RESULT_QUE', component: FollowupResultQue, meta: { title: '问卷调查--随访执行结果' } },
        //事务中心--转诊待办
        { path: 'business-center/transfer', name: 'PF_BUSINESS_CENTER_TRANSFER', component: BusinessCenterTransfer, meta: { title: '转诊待办' } },
        //事务中心--通知待办
        { path: 'business-center/notify', name: 'PF_BUSINESS_CENTER_NOTIFY', component: BusinessCenterNotify, meta: { title: '通知待办' } },
        //事务中心--随访待办
        { path: 'business-center/followup', name: 'PF_BUSINESS_CENTER_FOLLOWUP', component: BusinessCenterFollowUp, meta: { title: '随访待办' } },

        // 统计报表
        //问卷报表
        { path: 'report/que', name: 'PF_REPORT_QUE', component: QueReport, meta: { title: '问卷报表' } },
        //预约报表
        { path: 'report/reservation', name: 'PF_REPORT_RESERVATION', component: ReservationReport, meta: { title: '预约报表' } },
        //门诊报表
        { path: 'report/outpatient', name: 'PF_REPORT_OUTPATIENT', component: OutpatientReport, meta: { title: '门诊报表' } },
        //转诊报表
        { path: 'report/transfer', name: 'PF_REPORT_TRANSFER', component: TransferReport, meta: { title: '转诊报表' } },
        //随访报表
        { path: 'report/followUp', name: 'PF_REPORT_FOLLOWUP', component: FollowUpReport, meta: { title: '随访报表' } },
        //检测报表
        { path: 'report/check', name: 'PF_REPORT_CHECK', component: CheckReport, meta: { title: '检测报表' } },


        // 管理员端
        // 排班管理
        { path: 'scheduling/manage', name: 'PF_SCHEDULING_MANAGE', component: SchedulingManage, meta: { title: '排班管理' } },
        // 人员管理
        { path: 'doctor/manage', name: 'PF_DOCTOR_MANAGE', component: DoctorManage, meta: { title: '人员管理' } },
        // 站点管理
        { path: 'site/manage', name: 'PF_SITE_MANAGE', component: SiteManage, meta: { title: '站点管理' } },
        // 权限管理
        { path: 'manage/permission', name: 'PF_SET_PERMISSION', component: SetPermission, meta: { title: '权限管理' } },
        // 早筛报表
        { path: 'report-form/presieve', name: 'PF_REPORT_FORM_PRESIEVE', component: PresieveReport, meta: { title: '早筛报表' } },

        // 超级管理员
        // 医生管理
        { path: 'platform-user/doctor', name: 'PF_PLATFORM_USER_DOCTOR', component: DoctorUser, meta: { title: '医生管理' } },
        // 护士管理
        { path: 'platform-user/nurse', name: 'PF_PLATFORM_USER_NURSE', component: NurseUser, meta: { title: '护士管理' } },
        // 医院管理员
        { path: 'platform-user/amdin', name: 'PF_PLATFORM_USER_ADMIN', component: HospitalAdmin, meta: { title: '医院管理员' } },
        // 医生审核
        { path: 'platform-user/audit-doctor', name: 'PF_PLATFORM_USER_AUDIT_DOCTOR', component: AuditDoctor, meta: { title: '医生审核' } },
        // 护士审核
        { path: 'platform-user/audit-nurse', name: 'PF_PLATFORM_USER_AUDIT_NURSE', component: AuditNurse, meta: { title: '护士审核' } },
        // 护士服务列表
        { path: 'platform-user/nserver', name: 'PF_PLATFORM_USER_NURSE_SERVE', component: NurseServeList, meta: { title: '护士服务列表' } },
        // 护士服务编辑
        { path: 'platform-user/nserver/edit/:id', name: 'PF_BASE_NURSESERVER_EDIT', component: NurseServeEdit, meta: { title: '护士服务编辑' } },
        // 护士服务审核
        { path: 'platform-user/nserver/audit/:id', name: 'PF_BASE_NURSESERVER_AUDIT', component: NurseServeAudit, meta: { title: '护士服务审核' } },
        // 护士订单管理
        { path: 'order/nurse', name: 'PF_ORDER_NURSE', component: NurseOrder, meta: { title: '护士订单管理' } },
        // 医企端注册企业审核
        { path: 'platform-user/enterprise-audit', name: 'PF_PLATFORM_USER_ENTERPRISE_AUDIT', component: EnterpriseAudit, meta: { title: '企业审核信息' } },
        // 医企端注册企业审核
        { path: 'platform-user/enterprise-audit-info', name: 'PF_PLATFORM_USER_ENTERPRISE_AUDIT_INFO', component: EnterpriseAuditInfo, meta: { title: '注册企业审核' } },
        // 服务器日志
        { path: 'platform-user/server-log', name: 'PF_SERVER_LOG', component: ServerLog, meta: { title: '服务器日志' } },
        // 企业充值
        { path: 'platform-user/ep-account/charge', name: 'EP_WALLET_CHARGE', component: WalletCharge, meta: { title: '企业充值' } },
        // 资质审核
        { path: 'platform-user/audit/qualification', name: 'QUALIFICATION_AUDIT', component: QualificationAudit, meta: { title: '资质审核' } },
        // 资质审核详情
        { path: 'platform-user/audit/qualification/info/:id', name: 'QUALIFICATION_AUDIT_INFO', component: QualificationAuditInfo, meta: { title: '资质审核详情' } },
        // 配置管理
        // 角色资质管理
        { path: 'platform-user/configuration/qualification', name: 'CONFIGURATION_QUALIFICATION', component: ConfigurationQualification, meta: { title: '角色资质管理' } },
        // 合作申请
        { path: 'cooperate/website', name: 'OFFCIAL_WEBSITE', component: OffcialWebsite, meta: { title: '合作申请' } },


        // 医企端路由配置
        // 组织架构 人员管理
        { path: 'ep/framework/user', name: 'ENTERPRISE_USER', component: EnterpriseUser, meta: { title: '医企端人员管理' } },
        // 医企端身份管理
        // { path: 'ep/framework/role', name: 'ROLE_MANAGE', component: RoleManage, meta: { title: '医企端身份管理' } },
        // 身份管理编辑
        { path: 'ep/framework/role-edit/:id', name: 'ROLE_INFO_EDIT', component: RoleInfoEdit, meta: { title: '身份管理编辑' } },
        // 企业产品
        { path: 'ep/framework/products', name: 'EP_PRODUCTS', component: EpProdects, meta: { title: '企业产品' } },
        // 新增产品
        { path: 'ep/framework/products/add/:id', name: 'ADD_PRODUCTS', component: AddProdects, meta: { title: '新增产品' } },
        // 关联产品
        { path: 'ep/framework/products/connect', name: 'CONNECT_PRODUCTS', component: ConnectProdects, meta: { title: '关联产品' } },


        // 文件预览
        { path: 'ep/file/preview', name: 'FILE_PREVIEW', component: FilePreview, meta: { title: '文件预览' } },
        // 获取链接
        { path: 'get-link', name: 'OSS_LINK', component: OSSUrl, meta: { title: '文件链接' } },

        // 操作台 企业关联
        { path: 'ep/operate/connect', name: 'EP_CONNECT', component: EpConnect, meta: { title: '企业关联' } },
        // 审核文章
        { path: 'ep/article/audit', name: 'EP_ARTICLE_AUDIT', component: AuditArticle, meta: { title: '审核文章' } },
        // 发布文章
        { path: 'ep/article/release', name: 'EP_ARTICLE_RELEASE', component: ReleaseArticle, meta: { title: '发布文章' } },
        // 文章信息
        { path: 'ep/article/detail/:id', name: 'EP_ARTICLE_DETAIL', component: ArticleDetail, meta: { title: '文章信息' } },
        // 文章编辑
        { path: 'ep/article/edit/:id', name: 'EP_ARTICLE_EDIT', component: EditArticle, meta: { title: '文章编辑' } },
        // 考题列表
        { path: 'ep/question/list', name: 'EP_QUESTION_LIST', component: QuestionList, meta: { title: '考题列表' } },
        // 添加考题
        { path: 'ep/question/create/:id', name: 'EP_QUESTION_CREATE', component: CreateQuestion, meta: { title: '创建考题' } },
        // 发布任务
        { path: 'ep/task/manage', name: 'EP_TASK_MANAGE', component: TaskManage, meta: { title: '发布任务' } },
        // 新建任务
        { path: 'ep/task/create/:id', name: 'EP_TASK_CREATE', component: TaskCreate, meta: { title: '创建任务' } },
        // 任务详情
        { path: 'ep/task/detail/:id', name: 'EP_TASK_DETAIL', component: TaskDetail, meta: { title: '任务详情' } },
        // 任务审核
        { path: 'ep/task/audit/list', name: 'EP_TASK_AUDIT', component: TaskAudit, meta: { title: '任务审核' } },
        // 任务审核详情
        { path: 'ep/task/audit/info/:id', name: 'EP_TASK_AUDIT_INFO', component: TaskAuditInfo, meta: { title: '任务审核' } },
        // 任务结算
        { path: 'ep/task/settle', name: 'EP_TASK_SETTLE', component: TaskSettle, meta: { title: '任务结算' } },

        
        // 管理员流向报表
        { path: 'ep/tool/flow-report', name: 'EP_FLOW_REPORT', component: FlowReport, meta: { title: '流向报表' } },
        // 用户流向报表
        { path: 'ep/tool/flow-report-user', name: 'EP_FLOW_REPORT_USER', component: FlowReportUser, meta: { title: '流向报表' } },
        // 模版管理
        { path: 'ep/tool/templete-manage', name: 'EP_TEMPLETE_MANAGE', component: TempleteManage, meta: { title: '模版管理' } },
        // 添加模版
        { path: 'ep/tool/templete/create/:id', name: 'EP_TEMPLETE_CREATE', component: TempleteCreate, meta: { title: '新增模版' } },
        // 报表权限
        { path: 'ep/tool/flow-report/permission/manage', name: 'REPORT_PERMISSION_MANAGE', component: ReportPermission, meta: { title: '权限管理' } },
        // 创建权限
        { path: 'ep/tool/flow-report/permission/create/:id', name: 'REPORT_PERMISSION_CREATE', component: ReportPermissionCreate, meta: { title: '创建权限' } },

        // 运营中心
        // 钱包账号
        { path: 'ep/fund/wallet/ep', name: 'EP_WALLET_EP', component: WalletEp, meta: { title: '企业钱包' } },
        { path: 'ep/fund/wallet/user', name: 'EP_WALLET_USER', component: WalletUser, meta: { title: '用户钱包' } },
        
        
        // 企业信息修改
        { path: 'ep/account/edit', name: 'EP_ACCOUNT_EDIT', component: EditEnterpriseInfo, meta: { title: '医企端信息修改' } },


        // 医企端游用户身份
        // 我的任务
        { path: 'ep/task/list', name: 'EP_TASK_MY', component: MyTaskList, meta: { title: '我的任务' } },
        // 答题任务
        { path: 'ep/question/answer/:id', name: 'EP_ANSWER_QUE', component: AnswerQueTask, meta: { title: '游客答题' } },
        // 答题详情
        { path: 'ep/question/answer/detail/:id', name: 'EP_ANSWER_DETAIL', component: AnswerQueDetail, meta: { title: '答题详情' } },
        // 阅读文章
        { path: 'ep/article/read', name: 'EP_ARTICLE_READ', component: ArticleRead, meta: { title: '阅读文章' } },
        // pdf预览
        { path: 'ep/article/pdf/:id', name: 'EP_ARTICLE_PDF', component: ArticlePDF, meta: { title: 'PDF预览' } },
        // 阅读任务 阅读文章
        { path: 'ep/task/read/:id', name: 'EP_TASK_READ', component: TaskRead, meta: { title: '阅读任务' } },
        // 阅读任务 阅读文章
        { path: 'ep/task/create-que/:id', name: 'EP_CREATE_TASK_QUE', component: CreateTaskQue, meta: { title: '出题任务' } },




        // 专家角色
        { path: 'specialist/plan/medicine', name: 'PF_SPECIALIST_PLAN_MEDICINE', component: SpecialistMedicinePlan, meta: { title: '用药方案', keepAlive: true } },
        { path: 'specialist/plan/rehabilitation', name: 'PF_SPECIALIST_PLAN_REHABILITATION', component: SpecialistRehabilitationTraining, meta: { title: '康复训练', keepAlive: true } },
        { path: 'specialist/patient', name: 'PF_SPECIALIST_PATIENTLIST', component: SpecialistPatientList, meta: { title: '患者列表', keepAlive: true } },
        { path: 'specialist/patient/today', name: 'PF_SPECIALIST_PATIENTLIST_TODAY', component: SpecialistPatientListToday, meta: { title: '预约列表', keepAlive: true } },
        {
          path: 'patient/plan',
          name: 'PF_SPECIALIST_PATIENTLIST_INFO',
          component: SpecialistPatientInfo,
          meta: { title: '患者信息-撰写信息' },
          children: [
            { path: 'basic', name: 'PF_SPECIALIST_PATIENTLIST_INFO_BASIC_INFORMATION', component: SpecialistPatientInfoBasic, meta: { title: '就诊信息', keepData: true } },
            //预约列表-撰写方案
            { path: 'plan', name: 'PF_SPECIALIST_PATIENTLIST_INFO_PLAN_MAKING', component: SpecialistPatientInfoPlanMaking, meta: { title: '康复方案', keepData: true } },

            { path: 'medicine', name: 'PF_SPECIALIST_PATIENTLIST_INFO_MEDICINE_PLAN', component: SpecialistPatientInfoMedicinePlan, meta: { title: '用药方案', keepData: true } }
          ]
        },
        // 查看所有就诊档案
        { path: 'records', name: 'PF_SPECIALIST_PATIENTLIST_PATIENT_RECORDS', component: SpecialistPatientRecords, meta: { title: '就诊信息列表', keepData: true } },
        // 查看病人当前就诊档案
        {
          path: 'patient/info2',
          name: 'PF_SPECIALIST_PATIENTLIST_INFO2',
          component: SpecialistPatientInfo2,
          meta: { title: '患者信息-查看信息' },
          children: [
            { path: 'basic2', name: 'PF_SPECIALIST_PATIENTLIST_INFO_BASIC_INFORMATION2', component: SpecialistPatientInfoBasic2, meta: { title: '就诊信息2', keepData: true } },

            { path: 'plan2', name: 'PF_SPECIALIST_PATIENTLIST_INFO_PLAN_MAKING2', component: SpecialistPatientInfoPlanMaking2, meta: { title: '康复方案2', keepData: true } },
            { path: 'medicine2', name: 'PF_SPECIALIST_PATIENTLIST_INFO_MEDICINE_PLAN2', component: SpecialistPatientInfoMedicinePlan2, meta: { title: '用药方案2', keepData: true } }
          ]
        },
        // 非基层医院管理员
        { path: 'specialist/manager/doctors', name: 'PF_SPECIALIST_MANAGER_DOCTOR_MANAGE', component: specialistManagerDoctorManage, meta: { title: '人员管理', keepAlive: true } },
        { path: 'specialist/manager/schedule', name: 'PF_SPECIALIST_MANAGER_SCHEDULE', component: specialistManagerScheduleManagement, meta: { title: '排班管理', keepAlive: true } },
        { path: 'specialist/manager/appointment', name: 'PF_SPECIALIST_MANAGER_APPOINTMENT', component: specialistManagerAppointmentManagement, meta: { title: '预约记录', keepAlive: true } }
      ]
    },
    {
      path: '*',
      name: 'NOT_FOUND',
      component: NotFound,
      meta: {
        title: '页面不存在'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let name = to.name
  let token = Cookies.get('token')
  console.log('===>', to.path)
  if (name === 'LEAD_LOGIN' || name === 'LEAD_REG' || name === 'PF_APP_DOWNLOAD' || name === 'PF_PRIVACY' || name === 'PF_SERVICE') {
    goPage(true)
  } else if (name !== 'LOGIN') { // 若访问页面不是登录页
    // console.log('不是登陆页')
    // console.log('222555', token)
    if (!token) {
      this.$message.error('登录失败！')
      next({ name: 'LOGIN' })
    } else { // 已登录
      console.log('已登陆')
      if (name === 'NOT_FOUND') { // 若要前往404页面
        goPage(true)
      } else {
        // let flag = false;
        // while(i<weightList.length&&!flag){
        //     weightList[i].childMenu.forEach((item)=>{
        //         if(name.indexOf(item.code)>-1){
        //             flag = true;
        //         }
        //     })
        //     i++;
        // }
        goPage(true)
      }
    }
  } else {
    console.log('若访问页面是登录页!')
    goPage(true)
  }
  // goPage(true)
  function goPage(flag) {
    console.log(flag ? '有权限访问' : '无权限访问')
    flag ? next() : router.go(-1)
  }
})

// console.log('router==============>', router)

export default router



// WEBPACK FOOTER //
// ./src/router.js